import { render, staticRenderFns } from "./ChannelGroupPreviewModal.vue?vue&type=template&id=d2143b7e&"
import script from "./ChannelGroupPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupPreviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports